import styles from "./TermsAndConditions.module.scss";

export default function TermsAndConditions() {
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
  const contactPhone = process.env.REACT_APP_CONTACT_PHONE;
  return (
    <div className={styles["legal-container"]}>
      <h1 className={styles["legal-title"]}>Terms and Conditions</h1>

      <p className={styles["legal-paragraph"]}>
        Welcome to BeckyNews! By accessing this website, you accept these terms
        and conditions. If you do not agree, please do not use our site.
      </p>

      <h2 className={styles["legal-subtitle"]}>1. Use of Content</h2>
      <p className={styles["legal-paragraph"]}>
        All content is provided for informational purposes only. You may share
        content with attribution. You may not republish or reuse content
        commercially without permission.
      </p>

      <h2 className={styles["legal-subtitle"]}>2. Cookies</h2>
      <p className={styles["legal-paragraph"]}>
        We employ the use of cookies. By accessing BeckyNews, you agreed to use
        cookies in agreement with the BeckyNews’s Privacy Policy. Most
        interactive websites use cookies to let us retrieve the user’s details
        for each visit. Cookies are used by our website to enable the
        functionality of certain areas to make it easier for people visiting our
        website. Some of our affiliate/advertising partners may also use
        cookies.
      </p>
      <h2 className={styles["legal-subtitle"]}>3. Comments</h2>
      <p className={styles["legal-paragraph"]}>
        You are responsible for any comments or content you post. We reserve the
        right to remove any offensive or inappropriate submissions.
      </p>

      {/* <h2 className={styles["legal-subtitle"]}>
        4. Hyperlinking to our Content
      </h2>
      <p className={styles["legal-paragraph"]}>
        The following types of organizations may link to BeckyNews.com without
        prior written approval: 
        A. Government agencies 
        B. Search engines 
        C. News organizations 
        D. Online directory distributors, as they do with other
        listed businesses 
        E. System-wide accredited businesses (excluding
        non-profit groups, charity malls, and fundraising organizations) 

        These entities may link to our homepage, articles, or other content, provided
        the link: 
        A. Is not misleading 
        B. Does not falsely imply endorsement or
        sponsorship 
        C. Fits naturally within the context of the linking site 
        
        We may also approve links from other organizations, including: 
        A. Recognized consumer or business information sources 
        B. dot-com community websites
        C. Charitable associations or nonprofit groups 
        D. Internet portals 
        E. Law, accounting, or consulting firms 
        F. Educational institutions and trade
        associations 
        
        We will approve these requests if we determine that: 
        A. The link does not negatively affect our reputation 
        B. The organization has no recent history of legal or ethical issues with us 
        C. The link benefits BeckyNews.com through added visibility 
        D. The link is relevant and placed within a general resource or informational context How to Request a Link
        If your organization is listed above and you wish to link to our
        website, please email us at support@beckynews.com. Include: Your
        organization’s name Your contact information The URL(s) you intend to
        link from The specific BeckyNews.com URL(s) you want to link to Please
        allow 2–3 weeks for a response. Approved Linking Methods Approved
        organizations may link to our website using: Our name: BeckyNews The
        direct URL: https://beckynews.com A descriptive phrase that accurately
        represents our content in context Use of the BeckyNews logo or branding
        assets for linking is not permitted without a trademark license
        agreement.
      </p> */}
      <h2 className={styles["legal-subtitle"]}>4. Liability</h2>
      <p className={styles["legal-paragraph"]}>
        We are not liable for any content errors or damages from the use of this
        site.
      </p>

      <h2 className={styles["legal-subtitle"]}>5. Contact</h2>
      <p className={styles["legal-paragraph"]}>
        For inquiries, please contact: <br />
        <a href={`mailto:${contactEmail}`}>
          <span className={styles["legal-contact"]}>
            📧 Email: {contactEmail}
          </span>
        </a>
      </p>
      <p className={styles["legal-paragraph"]}>
        📞 Call: <span className={styles["legal-contact"]}>{contactPhone}</span>
      </p>
    </div>
  );
}
